export default "__VITE_ASSET__ee076d34__"